export const move = {
    namespaced: true,   
    state: {
        action:"",
        moveArray: [],
    },
    actions: {
        setAddMoveArray({ commit }, file) {
            commit('addMoveArray', file)
        },
        setCleanMoveArray({ commit }) {
            commit('cleanMoveArray')
        },
        setChangeAction({ commit }, cmd) {
            commit('changeAction', cmd)
        },
    },
    mutations: {
        addMoveArray(state, file) {
            state.moveArray = file;
        },
        cleanMoveArray(state) {
            state.moveArray.length = 0;
        },
        changeAction(state, cmd) {
            state.action = cmd;
        },
    }
};